import GameParameterInterface from '@/models/game/parameters/interface'

export default class PresentCatchParameter implements GameParameterInterface {

  createSetOption() {

    // プレゼントキャッチゲームのゲームスクリプト内でゲームの処理を記述しているGameObjectClass関数では、
    // optionsとしてresourceとtheme、nextPageUrlプロパティのみを使う。
    // これら3つのプロパティは client/src/services/game/executor/present-catch-executor.ts で定義されるため、
    // このcreateSetOptionでは空オブジェクトを返す。
    return {}
  }

  get guideUrl(): string {
    return ''
  }
}
